import { ModuleWithProviders, NgModule } from '@angular/core';
import { ThumborResizeService } from '@df/module-thumbor/thumbor-resize.service';
import { ResizeService } from '@df/ui/common/resize.service';
import defaultsDeep from 'lodash-es/defaultsDeep';
import { NThumbor } from './df-thumbor.interface';

@NgModule()
export class DfThumborModule {
    static forRoot(config?: Partial<NThumbor.IModuleOptions>): ModuleWithProviders<DfThumborModule> {
        return {
            ngModule: DfThumborModule,
            providers: [
                { provide: ResizeService, useExisting: ThumborResizeService },
                {
                    provide: NThumbor.OPTIONS,
                    useFactory: () => {
                        return defaultsDeep(config || {}, {
                            defaultOptions: {
                                fillColor: 'white',
                                upscale: true
                            }
                        });
                    }
                }
            ]
        };
    }
}
